module.exports = __webpack_public_path__ + "assets/img/kv-41b468f8.jpg";